import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { H6, List, ListItem } from '../base';
import { colors, fonts } from '../styles/theme';

const FooterListItem = styled(ListItem)`
  display: inline-block;
  margin-left: 15px;
  @media screen and (max-width: 800px) {
    display: block;
    margin: 0;
  }
`;

const FooterList = styled(List)`
  margin-left: auto;
  @media screen and (max-width: 800px) {
    margin: 0;
    text-align: center;
    padding-left: 0;
  }
`;

const Copyright = styled(H6)`
  font-size: 11px;
  letter-spacing: 0;
  margin: 0px;
  @media screen and (max-width: 800px) {
    order: 2;
    margin: 15px 0 5px;
    padding: 0;
    text-align: center;
  }
`;

const FooterWrapper = styled('div')`
  background: ${colors.white};
  font-size: ${fonts.sans.size.small};
  width: 100%;
  max-width: 1920px;
  padding: 10px 20px;
  height: 50px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    height: auto;
  }

  /* dropdown tweaks */
  ul[class*='DropdownMenu'] {
    bottom: 30px;
    box-shadow: 0 0 2px 0 ${colors.grey.altDark};
    border-radius: 3px 3px 0 0;
  }
  &:hover {
    [class*='DropdownContainerWrapper'] input {
      border-radius: 0 0 3px 3px;
    }
  }
`;

const Footer = ({ config }) => {
  const renderListItems = () =>
    config.listItems.map((li) => <FooterListItem key={li.toString()}>{li()}</FooterListItem>);

  return (
    <FooterWrapper>
      <Copyright>
        &copy; {new Date().getFullYear()} {config.copyright}
      </Copyright>
      <FooterList>{renderListItems()}</FooterList>
    </FooterWrapper>
  );
};

Footer.defaultProps = {
  config: {
    copyright: '',
    listItems: [],
  },
};

Footer.propTypes = {
  config: PropTypes.shape({
    copyright: PropTypes.string,
    listItems: PropTypes.arrayOf(PropTypes.func),
  }),
};

export default Footer;
